import { getGoldBotEvents } from "../services/goldBotEventsApi";
import { useGoldBotResource } from "./useGoldBotResource";

export const GOLD_BOT_EVENTS_POLL_INTERVAL_MS = 10000;

export function useGoldBotEvents() {
  return useGoldBotResource(
    getGoldBotEvents,
    GOLD_BOT_EVENTS_POLL_INTERVAL_MS
  );
}
